export default "__VITE_ASSET__Cga5cKEM__"